

import pipes from 'assets/png/machine-room/Technikraum_clickarea_01.png';
import pipesActive from 'assets/png/machine-room/Technikraum_clickarea_01_on.png';
import lights from 'assets/png/machine-room/Technikraum_clickarea_02.png';
import lightsActive from 'assets/png/machine-room/Technikraum_clickarea_02_on.png';
import air from 'assets/png/machine-room/Technikraum_clickarea_03.png';
import airActive from 'assets/png/machine-room/Technikraum_clickarea_03_on.png';
import monitor from 'assets/png/machine-room/Technikraum_clickarea_04.png';
import monitorActive from 'assets/png/machine-room/Technikraum_clickarea_04_on.png';
import heatAcc from 'assets/png/machine-room/Technikraum_clickarea_05.png';
import heatAccActive from 'assets/png/machine-room/Technikraum_clickarea_05_on.png';
import pump from 'assets/png/machine-room/Technikraum_clickarea_06.png';
import pumpActive from 'assets/png/machine-room/Technikraum_clickarea_06_on.png';

import background from 'assets/png/machine-room/Technikraum_BG.png';

export default {
  exitLabel: 'Raum verlassen',
  background: {
    src: background,
  },
  items: {
    pipes: {
      baseSrc: pipes,
      activeSrc: pipesActive,
      height: 23.6,
      top: 0,
      left: 1.6,
      level: 0,
      infopanel: {
        content: {
          title: 'Energiespartipp: Rohre dämmen',
          description: 'Verpassen Sie Ihren Heizungsrohren eine neue Garderobe – denn ungedämmte Leitungen haben einen hohen Energieverlust: Sind 20 Meter Ihrer Leitungen nicht fachgerecht eingepackt, verbrauchen Sie im Jahr rund 2.000 kWh mehr. Gibt es nicht-isolierte Warmwasser- oder Heizleitungen, die durch unbeheizte Räume führen – zum Beispiel durch Keller, Garagen oder Treppenhäuser?',
          link: {
            title: 'Jetzt handeln!',
            url: 'https://www.hde-klimaschutzoffensive.de/de/technische-sofortmassnahmen?pk_campaign=virtuelle-marktstrasse&pk_source=technikraum&pk_content=technische-sofortmassnahmen',
          },
        },
        overlay: {
          x: 'right',
          y: 'bottom',
        },
        button: {
          top: 95,
          left: 96.5,
        },
      },
    },
    lights: {
      baseSrc: lights,
      activeSrc: lightsActive,
      height: 12.1,
      top: 5.4,
      left: 44.1,
      level: 0,
      infopanel: {
        content: {
          title: 'Lichtsteuerung',
          description: 'Möchten Sie wissen, wie Sie ihr Licht so steuern können, dass Sie eine optimale und gleichzeitig effiziente Beleuchtung erreichen? Ob zeitliche Steuerung, Präsenzerfassung oder Tageslichtregelung, mit einer zentralen Lichtsteuerung lässt sich je nach Gebäude bis zu 45 Prozent Strom einsparen. Sie haben schon wieder vergessen, das Licht im Heizungsraum auszumachen? Na dann wird es allerhöchste Zeit, dass Sie die Sache in die Hand nehmen.',
          link: {
            title: 'Jetzt handeln!',
            url: 'https://www.hde-klimaschutzoffensive.de/de/lichtsteuerung?pk_campaign=virtuelle-marktstrasse&pk_source=technikraum&pk_content=lichtsteuerung',
          },
        },
        overlay: {
          x: 'right',
          y: 'bottom',
        },
        button: {
          top: 90,
          left: 12.5,
        },
      },
    },
    air: {
      baseSrc: air,
      activeSrc: airActive,
      height: 49.3,
      top: 21.6,
      left: 66.7,
      level: 0,
      infopanel: {
        content: {
          title: 'Klima- & Lüftungsanlagen',
          description: 'Klima- und Lüftungsanlagen werden in erster Linie dazu eingesetzt, die Luftfeuchtigkeit zu senken und die Raumluft zu filtern. Des Weiteren sorgen sie für eine angenehme Raumtemperatur durch Kühlen im Sommer und manchmal auch Heizen im Winter. Warum effiziente Klima- und Lüftungsanlagen immer mehr an Bedeutung gewinnen und wie auch Sie davon profitieren können, erklären wir Ihnen hier. ',
          link: {
            title: 'Jetzt handeln!',
            url: 'https://www.hde-klimaschutzoffensive.de/de/klimageraete?pk_campaign=virtuelle-marktstrasse&pk_source=technikraum&pk_content=klimageraete',
          },
        },
        overlay: {
          x: 'left',
          y: 'bottom',
        },
        button: {
          top: 3.5,
          left: -4.5,
        },
      },
    },
    monitor: {
      baseSrc: monitor,
      activeSrc: monitorActive,
      height: 14,
      top: 33.1,
      left: 84.6,
      level: 0,
      infopanel: {
        content: {
          title: 'Energiemanagement',
          description: 'Viele Investitionen in Energieeffizienz würden sich innerhalb kurzer Zeit amortisieren. Trotzdem zögern viele Einzelhändler, sie umzusetzen. Mit einem Energiemanagement können Sie dafür den Grundstein legen: Wie Sie Ihre Verbräuche und Kosten erfassen, bewerten und daraus dien passenden Sparmaßnahmen ableiten, zeigen wir in unseren Leitfäden. ',
          link: {
            title: 'Jetzt handeln!',
            url: 'https://www.hde-klimaschutzoffensive.de/de/energiemanagement?pk_campaign=virtuelle-marktstrasse&pk_source=technikraum&pk_content=energiemanagement',
          },
        },
        overlay: {
          x: 'left',
          y: 'bottom',
        },
        button: {
          top: -5,
          left: -6.5,
        },
      },
    },
    heatAcc: {
      baseSrc: heatAcc,
      activeSrc: heatAccActive,
      height: 19,
      top: 37.6,
      left: 45.5,
      level: 0,
      infopanel: {
        content: {
          title: 'Heizen',
          description: 'Haben auch Sie „Leichen im (Heizungs-) Keller“? Sie wissen es nicht? Dann wird es höchste Zeit, dass Sie sich auf Spurensuche begeben. Der erste Schritt bei der Optimierung der Wärmeversorgung ist, den Ist-Zustand Ihres Geschäftes hinsichtlich des aktuellen Energieverbrauchs der Anlagen und des Wärmebedarfs zu analysieren.',
          link: {
            title: 'Jetzt handeln!',
            url: 'https://www.hde-klimaschutzoffensive.de/de/heizen_aktuelle_technik?pk_campaign=virtuelle-marktstrasse&pk_source=technikraum&pk_content=heizen_aktuelle_technik',
          },
        },
        overlay: {
          x: 'left',
          y: 'bottom',
        },
        button: {
          top: 0,
          left: -7.5,
        },
      },
    },
    pump: {
      baseSrc: pump,
      activeSrc: pumpActive,
      height: 9.9,
      top: 28.05,
      left: 39.8,
      level: 0,
      infopanel: {
        content: {
          title: 'Hydraulischer Abgleich',
          description: 'Der hydraulische Abgleich einer Heizungsanlage erhöht die Energieeffizienz um bis zu 20 Prozent. Was bei dieser vergleichsweise günstigen Maßnahme eigentlich genau gemacht wird und warum ein hydraulischer Abgleich überhaupt nötig ist, erklären wir Ihnen in unserem Leitfaden zum Thema.',
          link: {
            title: 'Jetzt handeln!',
            url: 'https://www.hde-klimaschutzoffensive.de/de/hydraulischer_abgleich?pk_campaign=virtuelle-marktstrasse&pk_source=technikraum&pk_content=hydraulischer_abgleich',
          },
        },
        overlay: {
          x: 'left',
          y: 'bottom',
        },
        button: {
          top: 75,
          left: -25.5,
        },
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/config/MachineRoomConfig.js